import { required } from 'vuelidate/lib/validators';
import selectBox from '../../../common/components/select-box/select-box.vue';

import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueErrorMessage from '@ui-common/vue-error-message';

export default {
	props: {
		value: {
			required: true
		},
		id: {
			required: true
		},
		counties: {
			required
		},
		districts: {
			required
		},
		bankBranches: {
			required
		},
		submitted: {
			required
		},
		cardType: {
			required
		}
	},
	inheritAttrs: false,
	data() {
		return {
			model: {
				county: '',
				district: '',
				address: ''
			},
			restoreInprogress: false
		};
	},
	components: {
		selectBox,
		VueSelect,
		VueSelectOption,
		VueErrorMessage
	},
	validations() {
		let model = {};
		model.county = { required };
		model.district = this.model.county == 'budapest' || this.model.county == 'BUD' ? { required } : {};
		model.address = { required };
		return { model };
	},
	watch: {
		value(val) {
			if (val) {
				this.restore();
			}
		},
		submitted(value) {
			if (value) {
				this.$v.$touch();
			}
		},
		model: {
			handler() {
				this.$emit('input', this.model);
			},
			deep: true
		}
	},
	computed: {
		/* isMobile() {
			return this.$resize && this.$mq.below(767);
		} */
	},
	methods: {
		restore() {
			this.restoreInprogress = true;
			this.model.county = this.value.county || '';
			this.model.district = this.value.district || '';
			this.model.address = this.value.address || '';
			this.search();
		},
		search() {
			if (this.model.county) {
				this.$emit('bank-branch-search', {
					county: this.model.county,
					district: this.model.district
				});
			}
		},
		onDistrictChange() {
			if (this.restoreInprogress) {
				this.restoreInprogress = false;
			} else {
				this.model.address = '';
			}
			if (this.model.district && this.model.county) {
				this.search();
			}
		},
		onCountyChange() {
			if (this.restoreInprogress) {
				if (!this.model.district) {
					this.restoreInprogress = false;
				}
			} else {
				this.model.address = '';
			}
			if (this.model.county && (this.model.county != 'budapest' || this.model.county != 'BUD')) {
				this.model.district = '';
				this.search();
			} else if (this.model.district) {
				this.search();
			}
		}
	},
	created() {
		this.restore();
	}
};
